import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';
import { useProduct } from './product-context';
import ProductSkeleton from './product-skeleton';
import FauxOptions from './faux-options';
import SwatchSelector from './swatch-selector';
import FitSelector from './fit-selector';
import SizeVariantSelector from './size-variant-selector';
import LengthVariantSelector from './length-variant-selector';
import Denominations from './denominations';
import './variant-selector-group.css';

const VariantSelectorGroup = () => {
  const {
    lengthOptions, sizeOptions, colorOptions, allProducts, data,
  } = useProduct();
  const { activeProduct } = useProduct();
  const [selectedSizeAvailable, setSelectedSizeAvailable] = useState('');

  const length = activeProduct?.tags.find((a) => a.includes('length'));
  const denominationsName = activeProduct?.tags.find((tag) => tag.toLowerCase().includes('gift card'));
  const denominations = denominationsName ? activeProduct.options[0].values : null;

  const handleSelectedSize = (title) => {
    setSelectedSizeAvailable(title.split('/')[0].trim());
  };

  if (!allProducts) return <ProductSkeleton />;

  return (
    <>
      <FitSelector />
      {length && <FauxOptions />}
      {lengthOptions && <LengthVariantSelector />}
      {colorOptions && (
        <div id="colorselector">
          <SwatchSelector
            variantsWhiteish={data.variantsWhiteish}
            currentSizeAvailable={selectedSizeAvailable}
            thumbnailSwatches={data?.thumbnailSwatches}
          />
        </div>
      )}
      {sizeOptions && activeProduct?.productType !== 'Accessories: Gift Card' && activeProduct?.productType !== 'Gift Card' && <SizeVariantSelector onSizeSelected={handleSelectedSize} />}
      {denominations && <Denominations />}
    </>
  );
};

export default VariantSelectorGroup;
